// @ts-strict-ignore
/** @jsx jsx */
import React from 'react'
import { jsx, Themed } from 'theme-ui'
import { TruFacebook, TruTwitter, TruLinkedIn, TruEmail } from '@uswitch/spark-icons/tru'
import { Link } from '../helpers/react'

const SocialSharing = ({
  className = '',
  labelText = 'Share this guide',
  shareUrl,
  twitterMessage,
  mailSubject,
}) => {
  const styles = (element) => `compounds.social-sharing.${element}`

  const encodedShareUrl = encodeURIComponent(shareUrl)

  return (
    <Themed.div className={className} sx={{ variant: styles('main') }}>
      {(labelText && (
        <Themed.div
          sx={{
            variant: styles('label'),
            marginBottom: 8,
          }}
        >
          {labelText}
        </Themed.div>
      )) ||
        ''}

      <Themed.div
        sx={{
          variant: styles('buttons'),
        }}
      >
        <Link
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodedShareUrl}`}
          target='_blank'
          sx={{
            textDecoration: 'none',
            cursor: 'pointer',
            borderBottom: 0,
            variant: styles('fb'),
          }}
        >
          <TruFacebook size={20} color='#1877f2' />
        </Link>
        <Link
          href={`https://twitter.com/intent/tweet?${
            twitterMessage ? `text=${encodeURIComponent(twitterMessage)}` : `url=${encodedShareUrl}`
          }`}
          target='_blank'
          sx={{
            textDecoration: 'none',
            cursor: 'pointer',
            borderBottom: 0,
            variant: styles('tw'),
          }}
        >
          <TruTwitter size={20} color='#1d9bf0' />
        </Link>
        <Link
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedShareUrl}`}
          target='_blank'
          sx={{
            textDecoration: 'none',
            cursor: 'pointer',
            borderBottom: 0,
            variant: styles('ln'),
          }}
        >
          <TruLinkedIn size={24} color='#2867b2' />
        </Link>
        <Link
          href={`mailto:?subject=${encodeURIComponent(mailSubject)}&body=${encodedShareUrl}`}
          sx={{
            textDecoration: 'none',
            cursor: 'pointer',
            borderBottom: 0,
            variant: styles('email'),
          }}
        >
          <TruEmail size={16} color='primary' />
        </Link>
      </Themed.div>
    </Themed.div>
  )
}

export default SocialSharing
